<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created(){},
  methods:{
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  padding: 0;
}

::-webkit-scrollbar {
  width: 8px;
  position: absolute;
  background-color: rgba(0, 0, 0, 0);
  -webkit-border-radius: 100px;
}

::-webkit-scrollbar:hover {
  background-color: rgba(0, 0, 0, 0.09);
}

::-webkit-scrollbar:horizontal {
  height: 0;
}

::-webkit-scrollbar-thumb:vertical {
  background: rgba(0, 0, 0, 0.5);
  -webkit-border-radius: 100px;
}

::-webkit-scrollbar-thumb:vertical:active {
  background: rgba(0, 0, 0, 0.61);
  -webkit-border-radius: 100px;
}

@media screen and (min-width: 701px) {
  .mobile {
    display: none !important;
  }
}

@media screen and (max-width: 700px) {
  .pc {
    display: none !important;
  }
}
</style>
